import { RootState } from '../index';

const getSelectedIntegration = (state: RootState) => state.payrollReducer.selectedIntegration;

const getGustoData = (state: RootState) => state.payrollReducer.gustoData;

const getActiveStep = (state: RootState) => state.payrollReducer.activeStep;

const getGustoReportData = (state: RootState) => state.payrollReducer.gustoReportData;

const getMgmReportData = (state: RootState) => state.payrollReducer.mgmReportData;

export {
  getSelectedIntegration,
  getGustoData,
  getActiveStep,
  getGustoReportData,
  getMgmReportData,
};
